module.exports = __webpack_public_path__ + "static/favicon.43ea4d70.ico";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/favicon.ico
// module id = 217
// module chunks = 34471704633725 45593596689585